var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-alert",
    {
      staticClass: "not-found-screen",
      attrs: { value: true, type: "warning" },
    },
    [_vm._v("\n  404!!! ページがない又はページアクセスの権限がありません。\n")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }